<template>
    <v-row>
        <v-col cols="12">
            <oss-data-table
                :headers="headers"
                :items="companyBuildings"
                class="table elevation-0"
                fixed-header
                :items-per-page="-1"
                hide-default-footer
                density="compact"
            >
                <template #item.default="{ props }">
                    <tr>
                        <td class="text-left">{{ formatDate(props.item.acquiredDate) }}</td>
                        <td class="text-left">{{ props.item.natureA }}</td>
                        <td class="text-left">{{ props.item.name }}</td>
                        <td class="text-left">{{ props.item.address }}</td>
                        <td class="text-right">{{ props.item.city }}</td>
                        <td class="text-right">{{ props.item.country }}</td>
                    </tr>
                </template>
            </oss-data-table>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Company } from "../../../types/types/indexTypes";

@Component({
    components: {},
})
export class BuildingsTable extends Vue {
    @Prop({ default: null }) company!: Company;

    get headers() {
        return [
            { title: "Date", value: "acquiredDate", align: "left" },
            { title: "Type", value: "natureA", align: "left" },
            { title: "Nom", value: "name", align: "left" },
            { title: "Adresse", value: "address", align: "left" },
            { title: "Ville", value: "city", align: "right" },
            { title: "Pays", value: "country", align: "right" },
        ];
    }

    get companyBuildings() {
        return (this.company?.buildings as any)?.properties || null;
    }

    formatDate(date: moment.MomentInput): string {
        if (!date) return "";
        moment.locale("fr");
        return moment(date).format("DD/MM/YYYY");
    }
}

export default toNative(BuildingsTable);
</script>
